import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    height: 'auto' as any,
    maxHeight: '100vh' as any,
  },

  scrollViewBase: {
    flex: 1,
  },

  headerText: {
    width: '100%',
    fontSize: 16,
    fontWeight: '500',
  },

  content: {
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 16,
  },

  cardWrapper: {
    width: '100%',
  },

  cardWrapperWithError: {
    marginBottom: 4,
  },

  cardWrapperWithoutError: {
    // marginBottom: 16,
    marginBottom: 50,
  },

  errorBannerWrapper: {
    marginBottom: 16,
  },

  introCard: {
    width: '100%',
    backgroundColor: white,
    borderRadius: 16,
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 20,
    borderWidth: 1,
    borderColor: '#ECEFF3',
  },

  sectionTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111111',
    marginBottom: 8,
  },

  sectionDescription: {
    fontSize: 12,
    lineHeight: 18,
    color: '#667085',
    marginBottom: 16,
  },

  questionBlock: {
    marginTop: 4,
  },

  detailsCard: {
    backgroundColor: white,
    borderRadius: 16,
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 20,
    borderWidth: 1,
    borderColor: '#ECEFF3',
  },

  detailsCardDisabled: {
    opacity: 0.6,
  },

  detailsTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111111',
    marginBottom: 4,
  },

  detailsSubtitle: {
    fontSize: 12,
    lineHeight: 18,
    color: '#667085',
    marginBottom: 4,
  },

  fieldRow: {
    paddingTop: 20,
  },

  fieldRowLast: {
    paddingTop: 20,
    paddingBottom: 0,
  },

  fieldLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#414651',
    marginBottom: 10,
  },

  inputRowError: {
    borderColor: '#900B09',
  },

  inputRow: {
    borderWidth: 1,
    borderColor: '#E0E0E0',
    borderRadius: 8,
    backgroundColor: white,
    minHeight: 48,
    justifyContent: 'center',
    overflow: 'hidden',
  },

  textInput: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    minHeight: 48,
    fontSize: 14,
    lineHeight: 16,
    color: '#1C1C1E',
    fontFamily: 'OpenSans',
    textAlignVertical: 'center' as const,
    includeFontPadding: false,
  },

  textInputReadonlyWrapper: {
    minHeight: 48,
    justifyContent: 'center' as const,
  },

  textInputReadonly: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    fontSize: 14,
    lineHeight: 20,
    color: '#667085',
    fontFamily: 'OpenSans',
    includeFontPadding: false,
  },
  fieldError: {
    marginTop: 6,
    fontSize: 12,
    color: '#900B09',
    lineHeight: 18,
  },

  containerOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    borderRadius: 8,
    zIndex: 10,
  },

  errorScreen: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center' as const,
    paddingHorizontal: 24,
    paddingVertical: 24,
  },

  errorCard: {
    minHeight: 220,
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    paddingHorizontal: 24,
    paddingVertical: 32,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
  },

  errorContent: {
    width: '100%',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },

  errorIcon: {
    fontSize: 36,
    marginBottom: 12,
  },

  errorTitle: {
    fontSize: 18,
    textAlign: 'center' as const,
    fontWeight: '500',
  },

  errorSubtitle: {
    fontSize: 18,
    textAlign: 'center' as const,
    marginTop: 15,
    color: '#6B7280',
  },

  required: {
    color: '#EC221F',
    fontSize: 16,
  },
});
